/*

  Creek: Initialize, with modules.

  TODO:

  - Replace jQuery, Moment.js, and FontAwesome with smaller things.
  - Use "Creek.config" for config and "Creek.API.ModelName" for API data.

*/ 

/* ------------------------------------
  Create the global Creek object.
*/

// console.log(Creek);
// console.log(Creek.config);


var _scope = window.top.document;


//Only create if it doesn't exist
if(typeof _scope.Creek == "undefined"){
  // console.log("Creek: Creating Creek object.");
  _scope.Creek = {};
}

//Add placeholder config property if it doesn't exist
if(typeof _scope.Creek.config == "undefined"){
  _scope.Creek.config = {};
}

// Version string
_scope.Creek.version = "0.8.0";


import CreekConfig from './config-presets';
import CreekDebugInit from './util/debug';
import CreekUtil from './util/util';
import CreekContent from './util/content';

// Initial settings
_scope.Creek.config = CreekConfig.init(_scope.Creek.config);

// Initial debug message output, based on settings
_scope.Creek.debug = CreekDebugInit({ debug: true });

// Random utilities
_scope.Creek.util = CreekUtil;

/* ------------------------------------
 Include CSS libraries
*/

//FontAwesome
//
// !!! TODO: DON'T USE FONTAWESOME!
//     This should be replaced with individual icons.
//
// Modified CSS to have absolute URLs 
import css_fontawesome from './static/css/font-awesome.css';


/* ------------------------------------
 Initialize global object
*/

_scope.Creek.debug.log("Initializing.");

_scope.Creek.content = CreekContent;

_scope.Creek.API = { 
  Broadcasting: {
    now: null,
    next: null,
    upcoming: null,
    Track: null
  },
  Broadcast: {
    attributes: {},
    relationships: {
      tracks: []
    }
  },
  Shows: {

  },
  Station: {
    domain: null
  }
};

export default { Creek: _scope.Creek };
